import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { useLocale } from '../../i18n';
import { ConfigContext } from '../../config';
import { Root, AgreementLink } from './Agreement.styles'; // ссылки не переносятся - для этого между словами в ссылках и до/после союза неразрывные пробелы

var Agreement = function Agreement(_ref) {
  var submitButtonText = _ref.submitButtonText;

  var _useLocale = useLocale(),
      i18n = _useLocale.i18n;

  var _useContext = useContext(ConfigContext),
      _useContext$resources = _useContext.resources,
      resources = _useContext$resources === void 0 ? {} : _useContext$resources;

  var registerTerms = resources.registerTerms,
      registerPolicy = resources.registerPolicy;

  if (!registerTerms && !registerPolicy) {
    return null;
  }

  var terms = registerTerms ? _jsx(AgreementLink, Object.assign({
    href: registerTerms
  }, {
    children: i18n('agreement.termsLink')
  })) : '';
  var policy = registerPolicy ? _jsxs(_Fragment, {
    children: [_jsx(AgreementLink, Object.assign({
      href: registerPolicy
    }, {
      children: i18n('agreement.policyLink1')
    })), ' ', i18n('agreement.policyLink2')]
  }) : '';
  var separator = registerTerms && registerPolicy ? _jsxs(_Fragment, {
    children: ["\xA0", i18n('and'), "\xA0"]
  }) : '';
  return _jsxs(Root, {
    children: [i18n('agreement.description', submitButtonText), ' ', terms, separator, policy]
  });
};

export default Agreement;